import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

export default {
  markMessagesRead: async ({ commit }, data) => {
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      setTimeout(
        () =>
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen }),
        4000
      );
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },

  // NOTICE: KAPTION-INTEGRATION - Bulk mark conversations as read.
  // Resolves to the number of conversations that were updated. The caller is
  // responsible for refreshing the conversation list after the bulk update,
  // since we cannot efficiently mutate every conversation in the store.
  markAllRead: async (_ctx, filters = {}) => {
    try {
      const { data } = await ConversationApi.markAllRead(filters);
      return data?.updated_count ?? 0;
    } catch (error) {
      throwErrorMessage(error);
      return 0;
    }
  },
};
